import { Navigate, useParams, useSearch } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { useAuth } from 'react-oidc-context';
import { useGetProductionDeclaration } from '@/services/apis/queries/production-declaration/use-get-production-declaration';
import { ProductionDeclarationStatusCode } from '@/types/core/purchase-order/production-declaration-status-code';

function ProductionDeclarationSubmissionSuccess() {
  const { t } = useTranslation('productionDeclaration');

  return (
    <div className='mx-auto flex max-w-4xl flex-col items-center gap-8 px-6 py-20 text-center'>
      <h2 className='max-w-4xl font-semibold text-4xl text-declaration-foreground tracking-tight sm:text-5xl'>
        {t('submission.successTitle')}
      </h2>
      <p className='max-w-3xl text-[18px] text-declaration-foreground-muted leading-8 sm:text-[20px]'>
        {t('submission.successDescription')}
      </p>
    </div>
  );
}

export function ProductionDeclarationSubmissionPage() {
  const { id } = useParams({ strict: false });
  const { token } = useSearch({ strict: false });
  const { isAuthenticated } = useAuth();
  const { t } = useTranslation('productionDeclaration');
  const productionDeclarationId = `${id}`;
  const { data } = useGetProductionDeclaration(productionDeclarationId, token);

  if (isAuthenticated) {
    return (
      <Navigate
        params={{ id: productionDeclarationId }}
        replace
        search={{ token }}
        to='/production-declarations/$id/statement'
      />
    );
  }

  if (data.status.code === ProductionDeclarationStatusCode.Pending) {
    return (
      <Navigate
        params={{ id: productionDeclarationId }}
        replace
        search={{ token }}
        to='/production-declarations/$id/statement'
      />
    );
  }

  return (
    <div className='space-y-10'>
      <h1 className='font-semibold text-4xl text-declaration-foreground tracking-tight'>
        {t('submission.title')}
      </h1>
      <ProductionDeclarationSubmissionSuccess />
    </div>
  );
}
